export const TABLE_CACHE_TIME = 120000; // ms
export const STEP_MARK_CLASS = "mark-position";
export const STEP_MARK_CLASS_RIGHT_BORDER = "mark-position-right-border";
